import { Location } from 'EstraSponsor'

type UseLocationFields = {
  locations: Location[]
  selectedRegionId?: string
  selectedProvinceId?: string
  provincesOnly: boolean
}

type UseLocationFieldsOptions = {
  regionOptions?: {
    value: string
    label: string
  }[]

  provinceOptions: {
    value: string
    label: string
  }[]

  cityOptions: {
    value: string
    label: string
  }[]
}

export const useLocationFields = ({
  locations,
  selectedRegionId,
  selectedProvinceId,
  provincesOnly,
}: UseLocationFields): UseLocationFieldsOptions => {
  // Handle forms with both regions and provinces options, or forms with only the provinces
  if (!provincesOnly) {
    const allLocations = locations

    const regionOptions = allLocations.map((region) => ({
      value: region.id.toString(),
      label: region.name,
    }))

    const selectedRegion = [
      ...allLocations.filter(
        (region) => region.id.toString() === `${selectedRegionId}`
      ),
    ][0]

    const provinceOptions =
      selectedRegion && selectedRegion.provinces
        ? selectedRegion.provinces.map((province) => ({
            value: province.id.toString(),
            label: province.name,
          }))
        : []

    const selectedProvince = [
      ...(selectedRegion?.provinces || []).filter(
        (province) => province.id.toString() === `${selectedProvinceId}`
      ),
    ][0]

    const cityOptions =
      selectedProvince && selectedProvince.cities
        ? selectedProvince.cities.map((city) => ({
            value: city.id.toString(),
            label: city.name,
          }))
        : []

    return {
      regionOptions,
      provinceOptions,
      cityOptions,
    }
  } else {
    // Extract provinces from the regions in a flat array
    const allLocations = locations.flatMap((region) => region.provinces)

    const provinceOptions = allLocations.map((province) => ({
      value: province.id.toString(),
      label: province.name,
    }))

    const selectedProvince = [
      ...allLocations.filter(
        (province) => province.id.toString() === `${selectedProvinceId}`
      ),
    ][0]

    const cityOptions =
      selectedProvince && selectedProvince.cities
        ? selectedProvince.cities.map((city) => ({
            value: city.id.toString(),
            label: city.name,
          }))
        : []

    return {
      provinceOptions,
      cityOptions,
    }
  }
}
